function reloadPage() {
  global.location.reload();
}

export default reloadPage;
